import type { InternalAxiosRequestConfig, AxiosError } from 'axios';
import { cookie } from '@/presentation/index';
import * as Sentry from '@sentry/vue';

const onRequestError = (error: AxiosError): Promise<never> => {
	return Promise.reject(error);
};

const setTokenInHeaders = (config: InternalAxiosRequestConfig): void => {
	const tempToken = cookie.get('temp-token');
	const accessToken = cookie.get('access-token');
	const refreshToken = cookie.get('refresh-token');

	if (config?.useRefreshTokenOnly) {
		if (refreshToken) {
			config.headers['Authorization'] = `Bearer ${refreshToken}`;
		}
		return;
	}

	const token = accessToken || tempToken || refreshToken || '';
	if (token) {
		config.headers['Authorization'] = `Bearer ${token}`;
	}
};

const onRequest = (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
	Sentry.addBreadcrumb({
		category: 'http',
		message: `${config.method?.toUpperCase()} ${config.url}`,
		level: 'info',
	});
	setTokenInHeaders(config);
	return Promise.resolve(config);
};

export { onRequest, onRequestError };
